import React from 'react'
import Hero from '../Components/Hero/Hero'
import Newcollection from '../Components/Newcollection/Newcollection'
import Newsletter from '../Components/Newsletter/Newsletter'
const Shop = () => {
  return (
    <div><Hero/>
      <Newcollection/>
    
      
      <Newsletter/>
    </div>
  )
}

export default Shop
